export default __webpack_public_path__ + "static/media/Bullet 02.57517060.webp";